import React from 'react';
import './App.css';
import Covid_19_Tracker from './Covid_19_Tracker';

function App() {

  return (
  < Covid_19_Tracker/>
  );
}

export default App;
